(function() {
  function ready(fn) {
    document.readyState !== "loading" ? fn() : document.addEventListener("DOMContentLoaded", fn);
  }
  var DEMO_HEROES = window.MS_DEMO_AVATARS && window.MS_DEMO_AVATARS.length ? window.MS_DEMO_AVATARS : [];
  ready(function() {
    var root = document.querySelector("[data-ms-wizard]");
    if (!root) return;
    var openers = document.querySelectorAll("[data-open-preview]"), titleEl = root.querySelector("#ms-wiz-title"), backBtn = root.querySelector("[data-wiz-back]"), progressFill = root.querySelector("[data-wiz-progress-fill]"), coachText = root.querySelector("[data-wiz-coach-text]"), hasGrandmaFlow = root.getAttribute("data-has-grandma") === "true", variantId = root.getAttribute("data-variant-id"), coverUrl = root.getAttribute("data-cover-url") || "", productHandle = (root.getAttribute("data-product-handle") || "").toLowerCase(), COVER_BOOK_HANDLES = ["i-love-you-grandma", "i-love-you-dad", "i-love-you-mom", "the-back-to-school-bundle", "the-friendship-spark", "aventura-en-el-zoo", "el-quijote-para-pequenos", "gaudi-para-pequenos", "el-camino-de-santiago", "cristobal-colon", "pablo-picasso", "dinosaurios", "en-busca-del-tesoro", "mision-a-la-luna", "la-princesa-valiente", "el-poder-de-la-amistad", "la-sirena-del-oceano"];
    function isCoverBook() {
      return COVER_BOOK_HANDLES.indexOf(productHandle) !== -1;
    }
    function coverBookSlug() {
      return productHandle === "aventura-en-el-zoo" ? "zoo" : productHandle === "la-princesa-valiente" ? "princesa" : productHandle === "dinosaurios" ? "dino" : productHandle;
    }
    function coverTemplateUrl() {
      return ["dinosaurios", "aventura-en-el-zoo", "la-princesa-valiente"].indexOf(productHandle) === -1 ? coverUrl : root.getAttribute("data-cover-template-url") || "https://books-for-kids-hero.pablocamprubi.workers.dev/templates/" + coverBookSlug() + "-cover.png";
    }
    function coverAssetUrl(file) {
      var origin = root.getAttribute("data-cover-asset-origin") || "https://books-for-kids-hero.pablocamprubi.workers.dev";
      return origin + "/templates/" + file;
    }
    function getVariantId() {
      var fromWizard = root.getAttribute("data-variant-id"), pdp = document.querySelector("[data-ms-pdp]"), fromPdp = pdp && pdp.getAttribute("data-variant-id");
      return fromPdp || fromWizard || variantId;
    }
    var state = { step: "upload-child", childFileUrl: "", childFirst: "", childLast: "", childAge: "", childGender: "neutral", heroUrl: "", heroIndex: 0, heroSeed: null, heroRequestId: "", coverUrl: "", coverImage: "", coverRequestId: "", coverPending: false, coverFailed: false, archiveKey: "", archiveId: "", originalPhotoUrl: "", grandmaArchiveKey: "", grandmaArchiveId: "", grandmaPhotoUrl: "", regenCount: 0, contactMethod: "email", contactEmail: "", contactWhatsapp: "", contactSaved: false, editingNameFromSave: false, includeGrandma: false, grandmaFileUrl: "", grandmaName: "", history: [] }, TITLES = { "upload-child": "Crear personaje", "child-details": "Crear personaje", "child-meta": "Crear personaje", generating: "Creando magia", "meet-hero": "Conoce a tu h\xE9roe", "see-cover": "As\xED se ver\xE1 tu libro", "save-contact": "Crear personaje", "add-grandma": "A\xF1adir a la abuela", "upload-grandma": "Foto de la abuela", "grandma-details": "Nombre de la abuela", "book-preview": "Tu vista previa" }, COACH = { "upload-child": "Elige tu foto favorita. Mejor de frente y n\xEDtida.", "child-details": "Todo h\xE9roe necesita un nombre. \xBFC\xF3mo lo llamamos?", "child-meta": "Unos datos m\xE1s para que la historia parezca escrita solo para tu peque.", generating: "Un momento \u2014 la magia tarda un poquito.", "meet-hero": "\xA1Queda genial! Puedes regenerar o continuar.", "see-cover": "Te mostramos un ejemplo de c\xF3mo se ver\xE1 el libro. El arte final lo retocan artistas.", "save-contact": "Guarda a tu h\xE9roe para poder volver cuando quieras.", "add-grandma": "\xBFQuieres que la abuela salga tambi\xE9n en la historia?", "upload-grandma": "Sube una foto n\xEDtida y de frente de la abuela.", "grandma-details": "\xBFC\xF3mo la llamamos en el libro?", "book-preview": "Tu vista previa personalizada est\xE1 lista." }, errorEl = root.querySelector("[data-wiz-error]"), errorTitle = root.querySelector("[data-wiz-error-title]"), errorBody = root.querySelector("[data-wiz-error-body]"), errorRetry = root.querySelector("[data-wiz-error-retry]"), photoBanner = root.querySelector("[data-photo-banner]"), photoBannerClose = root.querySelector("[data-photo-banner-close]"), photoBannerText = root.querySelector("[data-photo-banner-text]"), retryFn = null, genTimer = null, coverJob = 0, portraitTask = null, generationRun = 0, generationPending = false, generationButton = null, generationLabel = null, generationLabelText = "", progressTimer = null, progressFill = null, photoBannerTimer = null, PHOTO_BANNER_DEFAULT = "Para un mejor resultado, usa un JPG o PNG n\xEDtido de la cara.", PHOTO_BANNER_PRIVACY = "Las fotos se usan solo de forma temporal para la vista previa y no se guardan en nuestros servidores.", PHOTO_BANNER_SOFT = "La foto vale, pero una imagen m\xE1s n\xEDtida (al menos 400\xD7400) suele quedar mejor impresa.", PHOTO_BANNER_HARD = "Elige otra foto que cumpla los consejos de abajo.", PHOTO_RULES = { maxBytes: 10 * 1024 * 1024, minW: 400, minH: 400, maxW: 6e3, maxH: 6e3 }, funnelStartedAt = null, stepEnteredAt = null, originalPhotoUpload = null, addingToCart = false;
    function productCtx() {
      return { product_handle: root.getAttribute("data-product-handle") || "", product_title: root.getAttribute("data-product-title") || "", variant_id: getVariantId() || "", has_grandma_flow: hasGrandmaFlow, wizard_step: state.step, include_grandma: !!state.includeGrandma, child_age: state.childAge || null, child_gender: state.childGender || null, has_child_name: !!state.childFirst, has_child_last_name: !!state.childLast, has_child_photo: !!state.childFileUrl, has_grandma_photo: !!state.grandmaFileUrl, has_grandma_name: !!state.grandmaName, hero_index: state.heroIndex, funnel_elapsed_ms: funnelStartedAt ? Date.now() - funnelStartedAt : null, step_elapsed_ms: stepEnteredAt ? Date.now() - stepEnteredAt : null };
    }
    var reliabilityId = "", reliabilitySeq = 0, reliabilityFailures = 0;
    var reliabilityAttempts = {}, reliabilityFailedStages = {};
    function classifyFailure(err) {
      var message = errorText(err).toLowerCase();
      if (/^(provider_balance|content_filter|timeout|interrupted|network|rate_limit|server|validation)$/.test(message)) return message;
      if (/balance|top.up|credit|saldo/.test(message)) return "provider_balance";
      if (/moderation|content.policy|content.filter|safety|nsfw|rejected.*content/.test(message)) return "content_filter";
      if (/timeout|timed.out|tiempo.*espera/.test(message)) return "timeout";
      if (/abort|cancel/.test(message)) return "interrupted";
      if (/network|load failed|failed to fetch|conexi/.test(message)) return "network";
      if (/429|rate.limit/.test(message)) return "rate_limit";
      if (/50[0-9]/.test(message)) return "server";
      if (/missing|invalid|not_saved|422|400/.test(message)) return "validation";
      return "unknown";
    }
    function reliability(name, extra) {
      try {
        extra = extra || {};
        if (name === "preview_funnel_opened") {
          reliabilityId = window.crypto && typeof window.crypto.randomUUID === "function" ? window.crypto.randomUUID() : Date.now().toString(36) + Math.random().toString(36).slice(2);
          reliabilitySeq = 0; reliabilityFailures = 0; reliabilityAttempts = {}; reliabilityFailedStages = {};
        }
        if (!reliabilityId) return;
        var match = /^preview_(generating|cover_generating|add_to_cart)_(started|clicked|completed|success|failed)$/.exec(name);
        var archive = /^preview_(photo|hero|metadata)_archive_(failed|recovered)$/.exec(name);
        if (!match && !archive && !/^preview_(funnel_opened|funnel_closed|error_shown|error_retry_clicked|photo_read_failed)$/.test(name)) return;
        var stage = match ? match[1] : archive ? archive[1] + "_archive" : "funnel";
        var outcome = match ? match[2] : archive ? archive[2] : name.replace("preview_", "");
        if (outcome === "started" || outcome === "clicked") reliabilityAttempts[stage] = (reliabilityAttempts[stage] || 0) + 1;
        var recovered = !!reliabilityFailedStages[stage] && /completed|success|recovered/.test(outcome);
        if (outcome === "failed" || outcome === "photo_read_failed") { reliabilityFailures++; reliabilityFailedStages[stage] = true; }
        if (recovered) delete reliabilityFailedStages[stage];
        var props = {
          tracking_version: "2026-10-20.1", via: "theme_reliability", funnel_id: reliabilityId,
          diagnostic_id: reliabilityId + ":" + (++reliabilitySeq), source_event: name,
          product_handle: root.getAttribute("data-product-handle") || "", wizard_step: state.step,
          stage: stage, outcome: outcome, attempt: reliabilityAttempts[stage] || 0,
          recovered_after_failure: recovered, failures_so_far: reliabilityFailures,
          duration_ms: typeof extra.duration_ms === "number" ? extra.duration_ms : null,
          elapsed_ms: funnelStartedAt ? Date.now() - funnelStartedAt : 0,
          error_category: /failed|error_shown/.test(outcome) ? classifyFailure(extra.error_code || extra.error_message || extra.error_reason) : null,
          http_status: typeof extra.http_status === "number" ? extra.http_status : null,
          regeneration_count: state.regenCount, retry_available: name === "preview_error_shown" ? !!retryFn : null
        };
        // A single owner and an explicit allowlist: no child details, photo URLs or raw provider messages.
        if (window.posthog && typeof window.posthog.capture === "function") window.posthog.capture("preview_reliability", props);
      } catch (ignored) {}
    }
    function track(name, extra) {
      reliability(name, extra);
      var props = productCtx();
      extra && Object.keys(extra).forEach(function(k) {
        props[k] = extra[k];
      });
      try {
        typeof window.msTrack == "function" ? window.msTrack(name, props) : window.posthog && typeof window.posthog.capture == "function" && window.posthog.capture(name, props);
      } catch (e) {
      }
    }
    function fileMeta(file) {
      return file ? { file_type: file.type || null, file_size_bytes: file.size || null, file_ext: ((file.name || "").split(".").pop() || "").toLowerCase() || null } : {};
    }
    function errorText(err) {
      if (err == null) return "";
      if (typeof err == "string") return err;
      if (typeof err == "number" || typeof err == "boolean") return String(err);
      var msg = err && err.message;
      if (typeof msg == "string" && msg && msg !== "[object Object]") return msg;
      if (err && typeof err.error == "string" && err.error) return err.error;
      if (msg && typeof msg == "object") return errorText(msg);
      if (err && err.error && typeof err.error == "object") return errorText(err.error);
      try {
        var serialized = JSON.stringify(err);
        if (serialized && serialized !== "{}" && serialized !== "null") return serialized;
      } catch (e) {
      }
      return "";
    }
    function asHeroError(err) {
      if (err instanceof Error && err.message && err.message !== "[object Object]") return err;
      var next = new Error(errorText(err) || "Algo ha fallado al crear el personaje. Pulsa Reintentar para regenerarlo.");
      return err && err.retryable && (next.retryable = true), next;
    }
    function displayErrorBody(err) {
      var msg = errorText(err).replace(/\s+/g, " ").trim();
      return !msg || msg === "[object Object]" || msg.charAt(0) === "{" || msg.charAt(0) === "[" ? "Algo ha fallado al crear el personaje. Pulsa Reintentar para regenerarlo." : msg.slice(0, 180);
    }
    function showError(opts) {
      opts = opts || {};
      var fallback = "Algo no ha cargado del todo bien. Suele arreglarse solo: pulsa Reintentar y seguimos donde lo dejamos.", body = opts.body;
      (!body || body === "[object Object]") && (body = fallback), errorTitle && (errorTitle.textContent = opts.title || "Ha habido un peque\xF1o tropiezo"), errorBody && (errorBody.textContent = body), retryFn = typeof opts.retry == "function" ? opts.retry : null, errorEl && (errorEl.hidden = false), track("preview_error_shown", { error_title: opts.title || "Ha habido un peque\xF1o tropiezo", error_reason: opts.reason || null, error_message: (opts.error_message || body || fallback).slice(0, 240) });
    }
    function hideError() {
      errorEl && (errorEl.hidden = true), retryFn = null;
    }
    function hidePhotoBanner() {
      photoBannerTimer && (clearTimeout(photoBannerTimer), photoBannerTimer = null), photoBanner && (photoBanner.hidden = true, photoBanner.classList.remove("is-recommend")), photoBannerText && (photoBannerText.textContent = PHOTO_BANNER_DEFAULT);
    }
    function setCheck(name, status) {
      if (photoBanner) {
        var li = photoBanner.querySelector('[data-check="' + name + '"]');
        li && (li.classList.remove("is-ok", "is-bad", "is-pending"), li.classList.add(status === true ? "is-ok" : status === false ? "is-bad" : "is-pending"));
      }
    }
    function showPhotoBanner(checks, opts) {
      if (opts = opts || {}, !!photoBanner) {
        setCheck("format", checks.format), setCheck("minRes", checks.minRes), setCheck("maxSize", checks.maxSize), setCheck("maxRes", checks.maxRes);
        var softWarn = !!checks.canProceed && !checks.ok, hardFail = checks.canProceed === false;
        photoBanner.classList.toggle("is-recommend", softWarn), photoBannerText && (hardFail ? photoBannerText.textContent = PHOTO_BANNER_HARD : softWarn ? photoBannerText.textContent = PHOTO_BANNER_SOFT : checks.ok ? photoBannerText.textContent = PHOTO_BANNER_PRIVACY : photoBannerText.textContent = PHOTO_BANNER_DEFAULT), photoBanner.hidden = false, photoBannerTimer && clearTimeout(photoBannerTimer);
        var hideAfter = opts.autoHide;
        hideAfter == null && (checks.ok ? hideAfter = 2200 : softWarn ? hideAfter = 4500 : hideAfter = 0), hideAfter && (checks.ok || softWarn || opts.forceAutoHide) && (photoBannerTimer = setTimeout(function() {
          hidePhotoBanner();
        }, hideAfter));
      }
    }
    function guessIsJpegOrPng(file) {
      var t = (file && file.type || "").toLowerCase();
      if (t === "image/jpeg" || t === "image/jpg" || t === "image/pjpeg" || t === "image/png") return true;
      var name = (file && file.name || "").toLowerCase();
      return !!/\.(jpe?g|png)$/.test(name);
    }
    function inspectImage(file) {
      return new Promise(function(resolve) {
        if (!file) {
          resolve({ format: false, maxSize: false, minRes: false, maxRes: false, ok: false, width: 0, height: 0, loadable: false });
          return;
        }
        var formatOk = guessIsJpegOrPng(file), sizeOk = file.size <= PHOTO_RULES.maxBytes, t = (file.type || "").toLowerCase(), looksLikeImage = formatOk || t.indexOf("image/") === 0 || !t;
        if (!looksLikeImage) {
          resolve({ format: false, maxSize: sizeOk, minRes: false, maxRes: false, ok: false, width: 0, height: 0, loadable: false });
          return;
        }
        var url = URL.createObjectURL(file), img = new Image(), settled = false;
        function finish(result) {
          if (!settled) {
            settled = true;
            try {
              URL.revokeObjectURL(url);
            } catch (e) {
            }
            resolve(result);
          }
        }
        img.onload = function() {
          var w = img.naturalWidth || img.width || 0, h = img.naturalHeight || img.height || 0, minRes = w >= PHOTO_RULES.minW && h >= PHOTO_RULES.minH, maxRes = w > 0 && h > 0 && w <= PHOTO_RULES.maxW && h <= PHOTO_RULES.maxH, formatPass = formatOk || w > 0 && h > 0;
          finish({ format: formatPass, maxSize: sizeOk, minRes, maxRes, ok: formatPass && sizeOk && minRes && maxRes, canProceed: sizeOk && w > 0 && h > 0, width: w, height: h, loadable: true });
        }, img.onerror = function() {
          finish({ format: formatOk, maxSize: sizeOk, minRes: false, maxRes: false, ok: false, canProceed: false, width: 0, height: 0, loadable: false });
        }, setTimeout(function() {
          finish({ format: formatOk, maxSize: sizeOk, minRes: false, maxRes: false, ok: false, canProceed: false, width: 0, height: 0, loadable: false, timedOut: true });
        }, 8e3), img.src = url;
      });
    }
    function handlePhotoSelect(file, kind) {
      hideError(), file && (track("preview_photo_selected", Object.assign({ photo_kind: kind }, fileMeta(file))), showPhotoBanner({ format: null, minRes: null, maxSize: null, maxRes: null, ok: false }), inspectImage(file).then(function(checks) {
        if (showPhotoBanner(checks), track("preview_photo_validated", Object.assign({ photo_kind: kind, format_ok: !!checks.format, size_ok: !!checks.maxSize, min_res_ok: !!checks.minRes, max_res_ok: !!checks.maxRes, can_proceed: !!checks.canProceed, fully_ok: !!checks.ok, width: checks.width || 0, height: checks.height || 0, loadable: !!checks.loadable, timed_out: !!checks.timedOut }, fileMeta(file))), !checks.canProceed) {
          track("preview_photo_rejected", Object.assign({ photo_kind: kind, width: checks.width || 0, height: checks.height || 0, timed_out: !!checks.timedOut }, fileMeta(file))), kind === "child" ? go("upload-child", { replace: true }) : go("upload-grandma", { replace: true });
          return;
        }
        var url;
        try {
          url = URL.createObjectURL(file);
        } catch (err) {
          showError({ reason: "photo_blob_failed", retry: function() {
            hideError();
          } });
          return;
        }
        if (kind === "child") {
          if (state.childFileUrl && state.childFileUrl.indexOf("blob:") === 0) try {
            URL.revokeObjectURL(state.childFileUrl);
          } catch (e) {
          }
          state.childFileUrl = url, state.originalPhotoUrl = "", state.archiveId = "", state.archiveKey = newArchiveKey(), track("preview_photo_accepted", Object.assign({ photo_kind: "child", width: checks.width, height: checks.height }, fileMeta(file))), originalPhotoUpload = archivePreview({ kind: "child", status: "preview" }), hidePhotoBanner(), startPortraitPrefetch(), go("child-details");
        } else {
          if (state.grandmaFileUrl && state.grandmaFileUrl.indexOf("blob:") === 0) try {
            URL.revokeObjectURL(state.grandmaFileUrl);
          } catch (e) {
          }
          state.grandmaFileUrl = url, state.grandmaArchiveKey = newArchiveKey(), state.grandmaPhotoUrl = "", state.grandmaArchiveId = "", track("preview_photo_accepted", Object.assign({ photo_kind: "grandma", width: checks.width, height: checks.height }, fileMeta(file))), archivePreview({ kind: "grandma", status: "preview", archiveKey: state.grandmaArchiveKey }), hidePhotoBanner(), go("grandma-details");
        }
      }).catch(function() {
        track("preview_photo_read_failed", Object.assign({ photo_kind: kind }, fileMeta(file))), showError({ reason: "photo_read_failed", body: "No hemos podido leer esa foto. Prueba con otro JPG o PNG.", retry: function() {
          hideError();
        } });
      }));
    }
    function open(source) {
      hideError(), hidePhotoBanner(), funnelStartedAt = Date.now(), stepEnteredAt = Date.now(), root.hidden = false, document.body.classList.add("ms-wiz-open"), track("preview_funnel_opened", { source: source || "unknown" }), go("upload-child", { replace: true });
    }
    function close(reason) {
      setGenerationWaiting(false), portraitTask = null, generationRun += 1, coverJob += 1, track("preview_funnel_closed", { close_reason: reason || "user", completed_preview: state.step === "book-preview" }), hideError(), hidePhotoBanner(), genTimer && (clearInterval(genTimer), genTimer = null), root.hidden = true, document.body.classList.remove("ms-wiz-open"), revokeUrls(), funnelStartedAt = null, stepEnteredAt = null;
    }
    function revokeUrls() {
      if (state.childFileUrl && state.childFileUrl.indexOf("blob:") === 0) try {
        URL.revokeObjectURL(state.childFileUrl);
      } catch (e) {
      }
      if (state.grandmaFileUrl && state.grandmaFileUrl.indexOf("blob:") === 0) try {
        URL.revokeObjectURL(state.grandmaFileUrl);
      } catch (e) {
      }
    }
    function readFile(file, cb, onError) {
      if (!file) {
        onError && onError("missing");
        return;
      }
      if (!file.type || file.type.indexOf("image/") !== 0) {
        showError({ title: "Ha habido un peque\xF1o tropiezo", body: "Ese archivo no parece una foto. Elige un JPG o PNG e int\xE9ntalo de nuevo.", retry: function() {
          hideError();
        } });
        return;
      }
      try {
        var url = URL.createObjectURL(file);
        cb(url);
      } catch (err) {
        showError({ retry: onError || function() {
          hideError();
        } });
      }
    }
    function updateNumberedSteps() {
      var stages = { "upload-child": 1, "child-details": 2, "child-meta": 2, "generating": 3, "meet-hero": 3, "see-cover": 3, "save-contact": 4, "add-grandma": 2, "upload-grandma": 2, "grandma-details": 2, "book-preview": 3 };
      var current = addingToCart ? 4 : (stages[state.step] || 1);
      root.querySelectorAll('[data-wiz-numbered-steps] li').forEach(function (item, index) {
        var number = index + 1;
        item.classList.toggle('is-current', number === current);
        item.classList.toggle('is-complete', number < current);
        if (number === current) item.setAttribute('aria-current', 'step');
        else item.removeAttribute('aria-current');
      });
    }

    function setProgress() {
      updateNumberedSteps();
      if (progressFill) {
        var map = hasGrandmaFlow ? { "upload-child": 10, "child-details": 20, "child-meta": 30, generating: 40, "meet-hero": 50, "see-cover": 52, "save-contact": 60, "add-grandma": 70, "upload-grandma": 80, "grandma-details": 90, "book-preview": 100 } : { "upload-child": 14, "child-details": 28, "child-meta": 42, generating: 56, "meet-hero": 70, "see-cover": 72, "save-contact": 85, "book-preview": 100 }, pct = map[state.step] != null ? map[state.step] : 14;
        progressFill.style.width = pct + "%";
      }
    }
    function go(step, opts) {
      opts = opts || {}, generationPending && step !== state.step && (generationRun += 1, setGenerationWaiting(false)), hideError();
      var fromStep = state.step;
      if (!opts.replace && state.step && state.step !== step && state.history.push(state.step), opts.replace && (state.history = []), state.step = step, stepEnteredAt = Date.now(), root.querySelectorAll("[data-step]").forEach(function(el) {
        var on = el.getAttribute("data-step") === step;
        el.hidden = !on, el.classList.toggle("is-active", on);
      }), titleEl && (titleEl.textContent = TITLES[step] || "Vista previa"), coachText && (step === "meet-hero" && state.childFirst ? coachText.textContent = "Esta es la foto de " + state.childFirst + " y su versi\xF3n ilustrada. Puedes generar una alternativa una sola vez." : step === "see-cover" && state.childFirst ? coachText.textContent = "Te mostramos un ejemplo de c\xF3mo se ver\xE1 el libro para " + state.childFirst + "." : step === "save-contact" && state.childFirst ? coachText.textContent = "Guarda a " + state.childFirst + " para poder volver cuando quieras." : step === "child-details" ? updateNameCoach() : coachText.textContent = COACH[step] || ""), backBtn) {
        var hideBack = step === "upload-child" || step === "generating";
        backBtn.hidden = hideBack;
      }
      step !== "upload-child" && step !== "upload-grandma" && hidePhotoBanner(), setProgress(), renderStep(), (fromStep !== step || opts.replace) && track("preview_step_viewed", { from_step: fromStep, to_step: step, replaced: !!opts.replace, step_title: TITLES[step] || step });
    }
    function pickHero() {
      return state.heroUrl ? state.heroUrl : state.childFileUrl && state.heroIndex === 0 ? state.childFileUrl : DEMO_HEROES[state.heroIndex % DEMO_HEROES.length];
    }
    function getHeroApiUrl() {
      var fromDom = root.getAttribute("data-hero-api-url") || "", fromCfg = window.MS_HERO_CONFIG && window.MS_HERO_CONFIG.apiUrl || "";
      return String(fromDom || fromCfg || "").replace(/\/$/, "");
    }
    function newArchiveKey() {
      return "fp-" + Date.now().toString(36) + "-" + Math.random().toString(36).slice(2, 10);
    }
    function heroHeaders() {
      var headers = { "Content-Type": "application/json", Accept: "application/json" }, secret = window.MS_HERO_CONFIG && window.MS_HERO_CONFIG.secret || "";
      return secret && (headers["X-Hero-Secret"] = secret), headers;
    }
    function sessionId() {
      try {
        if (window.posthog && typeof window.posthog.get_session_id == "function") return window.posthog.get_session_id() || "";
      } catch (e) {
      }
      return "";
    }
    var archiveTasks = Object.create(null);
    function archiveTelemetry(name, props) {
      reliability(name, props);
      // Archive diagnostics have one owner: avoid also sending them via Shopify's pixel.
      props = Object.assign(productCtx(), props, {via: "theme", archive_version: "2026-10-17"});
      try {
        if (window.posthog && typeof window.posthog.capture === "function") window.posthog.capture(name, props);
        else track(name, props);
      } catch (e) {}
    }
    function archivePreview(opts) {
      opts = opts || {};
      var apiUrl = getHeroApiUrl();
      if (!apiUrl) return opts.required ? Promise.reject(new Error("archive_not_configured")) : Promise.resolve(null);
      var kind = opts.kind || "child", key = opts.archiveKey || (kind === "grandma" ? state.grandmaArchiveKey || (state.grandmaArchiveKey = newArchiveKey()) : state.archiveKey || (state.archiveKey = newArchiveKey()));
      var source = kind === "grandma" ? state.grandmaFileUrl : state.childFileUrl;
      var stage = opts.skipPhoto ? (opts.heroUrl ? "hero" : "metadata") : "photo";
      var taskKey = key + ":" + stage + ":" + (opts.heroUrl || opts.status || "preview");
      var isCurrent = function() { return key === (kind === "grandma" ? state.grandmaArchiveKey : state.archiveKey); };
      var task = archiveTasks[taskKey];
      if (!task) {
        var payload = {archiveKey: key, kind: kind, childName: [state.childFirst, state.childLast].filter(Boolean).join(" "), childAge: state.childAge || "", childGender: state.childGender || "", productHandle: root.getAttribute("data-product-handle") || "", email: state.contactEmail || "", phone: state.contactWhatsapp || "", whatsapp: state.contactWhatsapp || "", contactMethod: state.contactMethod || "", sessionId: sessionId(), status: opts.status || "preview", heroUrl: opts.heroUrl || undefined, falRequestId: opts.falRequestId || state.heroRequestId || undefined, requestId: opts.falRequestId || state.heroRequestId || undefined};
        var photoPromise = opts.imageDataUrl ? Promise.resolve(opts.imageDataUrl) : opts.skipPhoto ? Promise.resolve(null) : source ? sourceBlobFromUrl(source).then(function(blob) { return blobToDataUrl(blob, 1600); }) : Promise.reject(new Error("archive_photo_missing"));
        var attempts = 0;
        task = photoPromise.then(function(imageDataUrl) {
          if (imageDataUrl) payload.imageDataUrl = imageDataUrl;
          function send() {
            if (!isCurrent()) throw new Error("archive_superseded");
            attempts++;
            return fetch(apiUrl + "/archive-preview", {method: "POST", headers: heroHeaders(), body: JSON.stringify(payload), keepalive: !imageDataUrl}).then(function(r) {
              return r.json().catch(function() { return {}; }).then(function(data) {
                if (!r.ok || data.ok !== true || data.skipped || (imageDataUrl && !/^https:\/\//.test(data.originalUrl || ""))) {
                  var err = new Error(data.pending ? "archive_processing" : !r.ok ? "archive_http_" + r.status : "archive_photo_url_missing");
                  err.reason = data.code || (data.pending ? "shopify_processing" : "unknown");
                  err.retryable = data.retryable !== false && (r.status === 429 || r.status >= 500 || !!data.pending || (r.ok && !data.skipped));
                  throw err;
                }
                return data;
              });
            }).catch(function(err) {
              if (isCurrent() && attempts < 4 && (err.retryable || err instanceof TypeError)) {
                return new Promise(function(resolve) { setTimeout(resolve, 600 * Math.pow(2, attempts - 1)); }).then(send);
              }
              throw err;
            });
          }
          return send();
        }).then(function(data) {
          if (isCurrent()) {
            if (kind === "grandma") { if (data.archiveId) state.grandmaArchiveId = data.archiveId; if (data.originalUrl) state.grandmaPhotoUrl = data.originalUrl; }
            else { if (data.archiveId) state.archiveId = data.archiveId; if (data.originalUrl) state.originalPhotoUrl = data.originalUrl; }
          }
          if (attempts > 1) archiveTelemetry("preview_" + stage + "_archive_recovered", {photo_kind: kind, attempts: attempts});
          return data;
        }).catch(function(err) {
          if (isCurrent() && err.message !== "archive_superseded") {
            var code = /^archive_[a-z0-9_]+$/.test(err.message || "") ? err.message : "archive_network_or_photo_error";
            archiveTelemetry("preview_" + stage + "_archive_failed", {photo_kind: kind, error_code: code, archive_reason: err.reason || "unknown", attempts: attempts});
          }
          throw err;
        });
        archiveTasks[taskKey] = task;
        task.then(function() { delete archiveTasks[taskKey]; }, function() { delete archiveTasks[taskKey]; });
      }
      return task.catch(function(err) { if (opts.required) throw err; return null; });
    }
    function blobToDataUrl(blob, maxEdge) {
      return maxEdge = maxEdge || 1024, new Promise(function(resolve, reject) {
        if (!blob) {
          reject(new Error("missing image"));
          return;
        }
        var url = URL.createObjectURL(blob), img = new Image();
        img.onload = function() {
          try {
            var w = img.naturalWidth || img.width || 1, h = img.naturalHeight || img.height || 1, scale = Math.min(1, maxEdge / Math.max(w, h)), cw = Math.max(1, Math.round(w * scale)), ch = Math.max(1, Math.round(h * scale)), canvas = document.createElement("canvas");
            canvas.width = cw, canvas.height = ch;
            var ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0, cw, ch);
            var dataUrl = canvas.toDataURL("image/jpeg", 0.88);
            URL.revokeObjectURL(url), resolve(dataUrl);
          } catch (err) {
            try {
              URL.revokeObjectURL(url);
            } catch (e) {
            }
            reject(err);
          }
        }, img.onerror = function() {
          try {
            URL.revokeObjectURL(url);
          } catch (e) {
          }
          reject(new Error("No hemos podido leer la foto"));
        }, img.src = url;
      });
    }
    function sourceBlobFromUrl(objectUrl) {
      return fetch(objectUrl).then(function(r) {
        if (!r.ok) throw new Error("No hemos podido leer la foto");
        return r.blob();
      });
    }
    function generateHeroWithFlux(opts) {
      return submitHeroJob(opts).catch(function(err) {
        if (!err || !err.retryable) throw asHeroError(err);
        return submitHeroJob(opts);
      });
    }
    function submitHeroJob(opts) {
      opts = opts || {};
      var apiUrl = getHeroApiUrl();
      if (!apiUrl) return Promise.reject(new Error("La API del h\xE9roe no est\xE1 configurada"));
      if (!state.childFileUrl) return Promise.reject(new Error("Falta la foto del peque"));
      var isCover = (opts.mode || "portrait") === "cover", sourcePromise = isCover && opts.faceUrl ? Promise.resolve(null) : sourceBlobFromUrl(opts.photoUrl || state.childFileUrl).then(function(blob) {
        return blobToDataUrl(blob, opts.maxEdge || (isCover ? 512 : 1024));
      });
      return sourcePromise.then(function(imageDataUrl) {
        if (opts.isCurrent && !opts.isCurrent()) throw new Error("stale_portrait");
        var payload = { imageDataUrl: isCover ? void 0 : imageDataUrl, photoDataUrl: isCover ? imageDataUrl : void 0, faceUrl: opts.faceUrl || void 0, childAge: opts.photoOnly ? "" : state.childAge || "", childGender: opts.photoOnly ? "neutral" : state.childGender || "neutral", kind: opts.kind || "child", mode: opts.mode || "portrait", seed: opts.seed, productHandle: root.getAttribute("data-product-handle") || "", archiveKey: opts.archiveKey || state.archiveKey || (state.archiveKey = newArchiveKey()), childName: [state.childFirst, state.childLast].filter(Boolean).join(" "), email: state.contactEmail || "", sessionId: sessionId() };
        return fetch(apiUrl + "/generate-hero", { method: "POST", headers: heroHeaders(), body: JSON.stringify(payload) }).then(function(r) {
          return r.json().then(function(data) {
            if (!r.ok) throw asHeroError({ message: data && (data.message || data.error) || "No se ha podido generar el personaje", retryable: !!(data && data.retryable) });
            return data;
          });
        });
      }).then(function(start) {
        if (!start || !start.requestId) throw new Error("No se ha recibido el identificador de generaci\xF3n");
        if (opts.isCurrent && !opts.isCurrent()) throw new Error("stale_portrait");
        return (opts.mode || "portrait") === "cover" ? (state.coverRequestId = start.requestId, state.coverFalModel = start.falModel || "cover") : (state.heroRequestId = start.requestId, state.heroSeed = start.seed != null ? start.seed : null, start.archiveKey && (state.archiveKey = start.archiveKey)), pollHeroStatus(apiUrl, start.requestId, opts.mode === "cover" ? 35 : 40, { archive: (opts.mode || "portrait") !== "cover", archiveKey: opts.archiveKey, isCurrent: opts.isCurrent, falModel: start.falModelId || start.falModel || (opts.mode === "cover" ? "cover" : "portrait") });
      });
    }
    function pollHeroStatus(apiUrl, requestId, maxAttempts, opts) {
      maxAttempts = maxAttempts || 90, opts = opts || {};
      var attempt = 0, doArchive = opts.archive !== false;
      function once() {
        return opts.isCurrent && !opts.isCurrent() ? Promise.reject(new Error("stale_portrait")) : (attempt += 1, fetch(apiUrl + "/generate-hero/status?requestId=" + encodeURIComponent(requestId) + (doArchive && state.archiveKey ? "&archiveKey=" + encodeURIComponent(opts.archiveKey || state.archiveKey) : "") + (opts.falModel ? "&model=" + encodeURIComponent(opts.falModel) : ""), { headers: { Accept: "application/json" } }).then(function(r) {
          return r.json().then(function(data) {
            if (!r.ok) throw asHeroError({ message: data && (data.message || data.error) || "Error al consultar el estado", retryable: !!(data && data.retryable) });
            return data;
          });
        }).then(function(data) {
          if (opts.isCurrent && !opts.isCurrent()) throw new Error("stale_portrait");
          var st = (data.status || "").toLowerCase();
          if (st === "completed") {
            if (!data.heroUrl) throw new Error("No se ha recibido la imagen del h\xE9roe");
            return doArchive && archivePreview({ skipPhoto: true, archiveKey: opts.archiveKey, heroUrl: data.heroUrl, falRequestId: data.requestId || requestId, status: "generated" }), data;
          }
          if (st === "failed") {
            var err = asHeroError({ message: data.error || "No se ha podido generar el personaje", retryable: !!data.retryable });
            throw err;
          }
          if (attempt >= maxAttempts) throw new Error("La generaci\xF3n ha tardado demasiado \u2014 int\xE9ntalo de nuevo");
          return new Promise(function(resolve) {
            setTimeout(function() {
              resolve(once());
            }, 2e3);
          });
        }));
      }
      return once();
    }
    function startGeneratingTitles(titleNode, subNode) {
      var name = state.childFirst || "tu h\xE9roe", titles = ["Creando a tu h\xE9roe\u2026", "Capturando la mirada y la sonrisa\u2026", "Pintando magia con calidad Pixar\u2026", "Ya casi est\xE1\u2026"];
      subNode && (subNode.textContent = isCoverBook() ? "Primero el personaje de " + name + " y despu\xE9s su portada." : "Convirtiendo esa foto en magia con calidad Pixar.");
      var i = 0;
      genTimer && clearInterval(genTimer), titleNode && (titleNode.textContent = titles[0]), genTimer = setInterval(function() {
        i += 1, titleNode && titles[i] && (titleNode.textContent = titles[i]), i >= titles.length - 1 && (clearInterval(genTimer), genTimer = null);
      }, 2200);
    }
    function loadCrossOriginImage(src) {
      return new Promise(function(resolve, reject) {
        var img = new Image();
        img.crossOrigin = "anonymous", img.onload = function() {
          resolve(img);
        }, img.onerror = function() {
          reject(new Error("image_load_failed"));
        }, img.src = src;
      });
    }
    var COVER_DIFF_LO = 12, COVER_DIFF_HI = 34, COVER_LUMA_PULL = 0.5, COVER_SAT_PULL = 0.6;
    function imageDataOf(img, w, h) {
      var c = document.createElement("canvas");
      c.width = w, c.height = h;
      var ctx = c.getContext("2d");
      return ctx.drawImage(img, 0, 0, w, h), ctx.getImageData(0, 0, w, h).data;
    }
    function blurGray(values, w, h, radius) {
      var c = document.createElement("canvas");
      c.width = w, c.height = h;
      for (var ctx = c.getContext("2d"), id = ctx.createImageData(w, h), i = 0, p = 0; i < values.length; i += 1, p += 4) id.data[p] = id.data[p + 1] = id.data[p + 2] = values[i], id.data[p + 3] = 255;
      ctx.putImageData(id, 0, 0);
      var out = document.createElement("canvas");
      out.width = w, out.height = h;
      var octx = out.getContext("2d");
      octx.filter = "blur(" + radius + "px)", octx.drawImage(c, 0, 0);
      for (var read = octx.getImageData(0, 0, w, h).data, res = new Float32Array(w * h), j = 0, q = 0; j < res.length; j += 1, q += 4) res[j] = read[q];
      return res;
    }
    function lumaOf(r, g, b) {
      return 0.299 * r + 0.587 * g + 0.114 * b;
    }
    function satOf(r, g, b) {
      var mx = Math.max(r, g, b), mn = Math.min(r, g, b);
      return mx > 0 ? (mx - mn) / mx : 0;
    }
    function composeCover(generatedUrl) {
      return Promise.all([loadCrossOriginImage(coverAssetUrl(coverBookSlug() + "-cover-base.jpg")), loadCrossOriginImage(coverAssetUrl(coverBookSlug() + "-cover-alpha.png")), loadCrossOriginImage(generatedUrl)]).then(function(imgs) {
        for (var base = imgs[0], ellipse = imgs[1], generated = imgs[2], w = base.naturalWidth || base.width, h = base.naturalHeight || base.height, n = w * h, baseData = imageDataOf(base, w, h), genData = imageDataOf(generated, w, h), ellipseData = imageDataOf(ellipse, w, h), diff = new Float32Array(n), ell = new Float32Array(n), i = 0, p = 0; i < n; i += 1, p += 4) diff[i] = (Math.abs(genData[p] - baseData[p]) + Math.abs(genData[p + 1] - baseData[p + 1]) + Math.abs(genData[p + 2] - baseData[p + 2])) / 3, ell[i] = ellipseData[p + 3];
        for (var diffBlur = blurGray(diff, w, h, 6), ellBlur = blurGray(ell, w, h, 8), raw = new Float32Array(n), k = 0; k < n; k += 1) {
          var t = (diffBlur[k] - COVER_DIFF_LO) / (COVER_DIFF_HI - COVER_DIFF_LO);
          t = t < 0 ? 0 : t > 1 ? 1 : t, raw[k] = t * Math.min(1, ellBlur[k] / 255 * 4) * 255;
        }
        for (var mask = blurGray(raw, w, h, 3), count = 0, baseLuma = 0, baseSat = 0, genLuma = 0, genSat = 0, s = 0, sp = 0; s < n; s += 1, sp += 4) mask[s] <= 128 || (count += 1, baseLuma += lumaOf(baseData[sp], baseData[sp + 1], baseData[sp + 2]), baseSat += satOf(baseData[sp], baseData[sp + 1], baseData[sp + 2]), genLuma += lumaOf(genData[sp], genData[sp + 1], genData[sp + 2]), genSat += satOf(genData[sp], genData[sp + 1], genData[sp + 2]));
        var gain = 1, satScale = 1;
        if (count > 1e3) {
          baseLuma /= count, baseSat /= count, genLuma /= count, genSat /= count, gain = (baseLuma + (1 - COVER_LUMA_PULL) * (genLuma - baseLuma)) / Math.max(genLuma, 1), gain = Math.min(1.2, Math.max(0.5, gain));
          var targetSat = genSat + COVER_SAT_PULL * (baseSat - genSat);
          satScale = Math.min(2, Math.max(1, targetSat / Math.max(genSat, 1e-3)));
        }
        var out = document.createElement("canvas");
        out.width = w, out.height = h;
        for (var outCtx = out.getContext("2d"), result = outCtx.createImageData(w, h), m = 0, mp = 0; m < n; m += 1, mp += 4) {
          var a = mask[m] / 255;
          if (a <= 0) {
            result.data[mp] = baseData[mp], result.data[mp + 1] = baseData[mp + 1], result.data[mp + 2] = baseData[mp + 2], result.data[mp + 3] = 255;
            continue;
          }
          var r = genData[mp] * gain, g = genData[mp + 1] * gain, b = genData[mp + 2] * gain, y = lumaOf(r, g, b);
          r = y + (r - y) * satScale, g = y + (g - y) * satScale, b = y + (b - y) * satScale, result.data[mp] = baseData[mp] * (1 - a) + Math.min(255, Math.max(0, r)) * a, result.data[mp + 1] = baseData[mp + 1] * (1 - a) + Math.min(255, Math.max(0, g)) * a, result.data[mp + 2] = baseData[mp + 2] * (1 - a) + Math.min(255, Math.max(0, b)) * a, result.data[mp + 3] = 255;
        }
        return outCtx.putImageData(result, 0, 0), out.toDataURL("image/jpeg", 0.92);
      });
    }
    function startCoverJob() {
      var job = coverJob += 1, startedAt = Date.now();
      track("preview_cover_generating_started", { cover_attempt: job }), state.coverPending = true, state.coverFailed = false, state.coverUrl = "", state.coverImage = "", state.step === "see-cover" && renderCoverPreview(), generateHeroWithFlux({ kind: "child", mode: "cover", faceUrl: state.heroUrl || void 0 }).then(function(cover) {
        if (job !== coverJob) return null;
        if (!cover || !cover.heroUrl) throw new Error("cover_missing");
        return state.coverUrl = cover.heroUrl, state.coverImage = cover.heroUrl, state.coverRequestId = cover.requestId || "", state.coverPending = false, state.coverFailed = false, track("preview_cover_generating_completed", { cover_attempt: job, duration_ms: Date.now() - startedAt }), null;
      }).catch(function(err) {
        job === coverJob && (state.coverPending = false, state.coverFailed = true, track("preview_cover_generating_failed", { cover_attempt: job, duration_ms: Date.now() - startedAt, error_code: classifyFailure(err) }));
      }).then(function() {
        job === coverJob && state.step === "see-cover" && renderCoverPreview();
      });
    }
    function startPortraitPrefetch() {
      var task = { photoUrl: state.childFileUrl, result: null, error: null, startedAt: Date.now(), progress: 0 };
      return portraitTask = task, generationRun += 1, coverJob += 1, state.heroUrl = "", state.heroRequestId = "", state.heroSeed = null, getHeroApiUrl() ? (task.promise = generateHeroWithFlux({ kind: "child", photoOnly: true, photoUrl: task.photoUrl, archiveKey: state.archiveKey, isCurrent: function() {
        return portraitTask === task;
      } }).then(function(data) {
        if (!data || !data.heroUrl) throw new Error("No se ha recibido la imagen del h\xE9roe");
        return new Promise(function(resolve, reject) {
          var previewImage = new Image(), timeout = setTimeout(function() {
            finish(new Error("La imagen ha tardado demasiado en cargar"));
          }, 3e4), settled = false;
          function finish(err) {
            if (!settled) {
              if (settled = true, clearTimeout(timeout), previewImage.onload = previewImage.onerror = null, err) return reject(err);
              task.result = data, resolve(data);
            }
          }
          previewImage.onload = function() {
            finish();
          }, previewImage.onerror = function() {
            finish(new Error("No hemos podido cargar la imagen del personaje"));
          }, task.image = previewImage, previewImage.src = data.heroUrl;
        });
      }).catch(function(err) {
        return task.error = err, null;
      }), task) : null;
    }
    function renderGenerationProgress(complete) {
      if (generationLabel) {
        var task = portraitTask, seconds = task ? (Date.now() - task.startedAt) / 1e3 : 0, value = complete ? 100 : Math.min(95, Math.floor(seconds <= 12 ? 90 * (1 - Math.exp(-seconds / 4)) : 85 + 10 * (1 - Math.exp(-(seconds - 12) / 60))));
        task && (value = Math.max(task.progress || 0, value), task.progress = value);
        var text = generationLabel.querySelector("[data-generation-percent]");
        text && (text.textContent = (complete ? "Imagen lista \xB7 " : "Generando imagen\u2026 ") + value + "%"), progressFill && (progressFill.style.width = value + "%"), generationButton && generationButton.setAttribute("aria-label", complete ? "Imagen lista, 100%" : "Generando imagen, progreso estimado " + value + "%");
      }
    }
    function setGenerationWaiting(waiting) {
      generationPending = waiting, progressTimer && (clearInterval(progressTimer), progressTimer = null), waiting ? (generationButton = root.querySelector('[data-step="' + state.step + '"] [data-wiz-next]'), generationLabel = generationButton && (generationButton.querySelector(".ms-wiz-btn__label") || generationButton), generationLabel && (generationLabelText = generationLabel.innerHTML, generationLabel.innerHTML = '<span style="position:relative;z-index:2;display:inline-flex;flex-direction:column;align-items:center;line-height:1.2"><span data-generation-percent>Generando imagen\u2026 0%</span><small style="font-size:10px;font-weight:400;opacity:.85">Progreso estimado</small></span>'), generationButton && (generationButton.disabled = true, generationButton.setAttribute("aria-busy", "true"), progressFill = document.createElement("span"), progressFill.setAttribute("aria-hidden", "true"), progressFill.style.cssText = "position:absolute;left:0;top:0;bottom:0;width:0;pointer-events:none;background:rgba(255,255,255,.28);border-radius:inherit;z-index:1;transition:width .6s linear", generationButton.appendChild(progressFill)), renderGenerationProgress(false), progressTimer = setInterval(function() {
        renderGenerationProgress(false);
      }, 500)) : (progressFill && (progressFill.remove(), progressFill = null), generationLabel && (generationLabel.innerHTML = generationLabelText), generationButton && (generationButton.disabled = false, generationButton.removeAttribute("aria-busy"), generationButton.removeAttribute("aria-label")), generationButton = null, generationLabel = null);
    }
    function runGenerating(thenStep) {
      if (!generationPending) {
        var run = ++generationRun, task = portraitTask;
        getHeroApiUrl() && (!task || task.photoUrl !== state.childFileUrl || task.error) && (task = startPortraitPrefetch(), run = ++generationRun), coverJob += 1, state.coverUrl = "", state.coverImage = "", state.coverPending = false, state.coverFailed = false, track("preview_generating_started", { next_step: thenStep || "meet-hero", child_age: state.childAge || null, child_gender: state.childGender || null, has_hero_api: !!getHeroApiUrl(), generate_cover: isCoverBook() }), setGenerationWaiting(true);
        var genStarted = Date.now(), apiUrl = getHeroApiUrl(), work;
        apiUrl ? work = task.promise.then(function(data) {
          if (run !== generationRun || portraitTask !== task) throw new Error("stale_portrait");
          if (task.error) throw task.error;
          if (!data || !data.heroUrl) throw new Error("No se ha recibido la imagen del h\xE9roe");
          return state.heroUrl = data.heroUrl, state.heroSeed = data.seed != null ? data.seed : null, state.heroRequestId = data.requestId || "", state.heroIndex = 0, data;
        }) : work = new Promise(function(resolve) {
          setTimeout(function() {
            state.heroIndex = 0, state.heroUrl = state.childFileUrl || pickHero(), resolve({ heroUrl: state.heroUrl, fallback: true });
          }, 2100);
        }), work.then(function(data) {
          return run !== generationRun ? data : (renderGenerationProgress(true), new Promise(function(resolve) {
            setTimeout(function() {
              resolve(data);
            }, 350);
          }));
        }).then(function(data) {
          if (run === generationRun) {
            setGenerationWaiting(false), genTimer && (clearInterval(genTimer), genTimer = null);
            var next = thenStep || "meet-hero";
            isCoverBook() && !apiUrl && (state.coverUrl = "", state.coverImage = "", state.coverPending = false, state.coverFailed = true), track("preview_generating_completed", { duration_ms: Date.now() - genStarted, next_step: next, used_flux: !(data && data.fallback), used_uploaded_photo: !!(data && data.fallback), hero_seed: state.heroSeed, has_cover: !!state.coverUrl }), go(next);
          }
        }).catch(function(err) {
          run === generationRun && (setGenerationWaiting(false), genTimer && (clearInterval(genTimer), genTimer = null), track("preview_generating_failed", { duration_ms: Date.now() - genStarted, error_message: (errorText(err) || "unknown").slice(0, 240) }), go("child-meta", { replace: true }), showError({ reason: "generating_failed", title: "No hemos podido crear a tu h\xE9roe", body: displayErrorBody(err), error_message: (errorText(err) || "unknown").slice(0, 240), retry: function() {
            hideError(), runGenerating(thenStep || "meet-hero");
          } }));
        });
      }
    }
    var MAX_REGENERATIONS = 1;
    function syncRegenerationButton() {
      root.querySelectorAll("[data-wiz-regen]").forEach(function(btn) {
        btn.hidden = state.regenCount >= MAX_REGENERATIONS, btn.disabled = state.regenCount >= MAX_REGENERATIONS || generationPending || addingToCart;
      });
    }
    function regenerateHero() {
      if (!(generationPending || addingToCart)) {
        if (state.regenCount >= MAX_REGENERATIONS) {
          showError({ title: "Has llegado al l\xEDmite de regeneraciones", body: "Ya has usado tu regeneraci\xF3n. Contin\xFAa con este personaje.", reason: "regen_limit", retry: function() {
            hideError();
          } });
          return;
        }
        var apiUrl = getHeroApiUrl();
        if (track("preview_hero_regenerated", { regen_count: state.regenCount + 1, has_hero_api: !!apiUrl }), state.regenCount += 1, syncRegenerationButton(), !apiUrl) {
          state.heroIndex = (state.heroIndex + 1) % Math.max(DEMO_HEROES.length, 1), state.heroUrl = "", renderStep();
          return;
        }
        if (state.step === "see-cover") {
          startCoverJob(), renderCoverPreview();
          return;
        }
        portraitTask = null, runGenerating("meet-hero");
      }
    }
    function renderStep() {
      if (syncRegenerationButton(), state.step === "child-details" && syncNameUI(), state.step === "child-meta" && syncMetaUI(), state.step === "save-contact" && syncSaveContactUI(), state.step === "meet-hero") {
        state.heroUrl = pickHero();
        var hero = root.querySelector("[data-hero-img]"), photo = root.querySelector("[data-hero-photo]"), nameOut = root.querySelector("[data-child-name-out]");
        hero && (hero.src = state.heroUrl), photo && state.childFileUrl && (photo.src = state.childFileUrl), nameOut && (nameOut.textContent = state.childFirst || "tu h\xE9roe");
      }
      if (state.step === "see-cover" && (!state.coverUrl && !state.coverPending && !state.coverFailed && startCoverJob(), renderCoverPreview()), state.step === "grandma-details") {
        var gthumb = root.querySelector("[data-grandma-thumb]");
        gthumb && state.grandmaFileUrl && (gthumb.src = state.grandmaFileUrl);
      }
      state.step === "book-preview" && renderBookPreview();
    }
    function updateNameCoach() {
      if (coachText) {
        var first = ((root.querySelector("[data-child-first]") || {}).value || "").trim(), last = ((root.querySelector("[data-child-last]") || {}).value || "").trim(), full = [first, last].filter(Boolean).join(" ");
        full ? coachText.textContent = full + ". Revisa bien la ortograf\xEDa para el libro." : coachText.textContent = COACH["child-details"];
      }
    }
    function syncNameUI() {
      var firstInput = root.querySelector("[data-child-first]"), lastInput = root.querySelector("[data-child-last]"), cover = root.querySelector("[data-name-cover]"), coverValue = root.querySelector("[data-name-cover-value]"), hint = root.querySelector("[data-name-hint]"), btn = root.querySelector("[data-name-continue]"), label = root.querySelector("[data-name-continue-label]"), first = (firstInput && firstInput.value || "").trim(), last = (lastInput && lastInput.value || "").trim(), full = [first, last].filter(Boolean).join(" ");
      cover && coverValue && (full ? (cover.hidden = false, coverValue.textContent = full, hint && (hint.hidden = true)) : (cover.hidden = true, coverValue.textContent = "", hint && (hint.hidden = false))), btn && (btn.disabled = !first), label && (first ? label.innerHTML = 'Confirmar nombre <span aria-hidden="true">\u2192</span>' : label.innerHTML = 'Escribe el nombre del h\xE9roe <span aria-hidden="true">\u2191</span>'), updateNameCoach();
    }
    function coverDisplayUrl() {
      return state.coverImage || state.coverUrl || "";
    }
    function renderCoverPreview() {
      var img = root.querySelector("[data-cover-img]"), nameEl = root.querySelector("[data-cover-child-name]"), loading = root.querySelector("[data-cover-loading]"), stage = root.querySelector("[data-cover-stage]"), ready2 = !!coverDisplayUrl() && !state.coverPending && !state.coverFailed, accept = root.querySelector('[data-step="see-cover"] [data-wiz-next]');
      if (accept && (accept.disabled = !ready2), img && (ready2 && (img.src = coverDisplayUrl()), img.hidden = !ready2), stage && stage.setAttribute("data-state", ready2 ? "ready" : state.coverFailed ? "failed" : "loading"), loading) {
        loading.hidden = ready2;
        var loadingText = loading.querySelector("[data-cover-loading-text]") || loading;
        loadingText.textContent = state.coverFailed ? "No hemos podido personalizar la portada. Pulsa Regenerar." : "Personalizando el libro, te mostramos la portada\u2026";
      }
      nameEl && (nameEl.textContent = "", nameEl.hidden = true);
    }
    function renderBookPreview() {
      var cover = root.querySelector("[data-book-cover]"), badge = root.querySelector("[data-book-names]"), summary = root.querySelector("[data-wiz-summary]"), firstThumb = root.querySelector("[data-page-src] img");
      firstThumb && coverDisplayUrl() && (firstThumb.src = coverDisplayUrl()), cover && (cover.src = coverDisplayUrl() || coverUrl, cover.parentElement && cover.parentElement.classList.toggle("is-personal-cover", !!coverDisplayUrl()));
      var fullName = [state.childFirst, state.childLast].filter(Boolean).join(" "), lines = [];
      if (fullName && lines.push("Protagonista: " + fullName), state.includeGrandma && state.grandmaName && lines.push("Con " + state.grandmaName), badge && (badge.textContent = lines.join(" \xB7 ") || "Tu libro personalizado"), summary) {
        var genderLabel = state.childGender === "girl" ? "Ni\xF1a" : state.childGender === "boy" ? "Ni\xF1o" : "\u2014", items = [["Peque", fullName || "\u2014"], ["Edad", state.childAge || "\u2014"], ["G\xE9nero", genderLabel]];
        hasGrandmaFlow && (items.push(["Abuela", state.includeGrandma ? state.grandmaName || "Incluida" : "Sin a\xF1adir"]), state.includeGrandma && items.push(["Extra abuela", "+4,99 \u20AC"])), summary.innerHTML = items.map(function(pair) {
          return "<li><span>" + pair[0] + "</span><span>" + escapeHtml(pair[1]) + "</span></li>";
        }).join("");
      }
    }
    function escapeHtml(str) {
      return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
    }
    function validateChildDetails() {
      var firstInput = root.querySelector("[data-child-first]"), first = (firstInput && firstInput.value || "").trim();
      return root.querySelectorAll(".is-invalid").forEach(function(el) {
        el.classList.remove("is-invalid");
      }), first ? (state.childFirst = first, state.childLast = ((root.querySelector("[data-child-last]") || {}).value || "").trim(), true) : (firstInput && (firstInput.classList.add("is-invalid"), firstInput.focus()), syncNameUI(), false);
    }
    function syncMetaUI() {
      var ageSlider2 = root.querySelector("[data-child-age-slider]"), ageHidden2 = root.querySelector("[data-child-age]"), ageValue2 = root.querySelector("[data-age-value]"), age = state.childAge || ageSlider2 && ageSlider2.value || "4";
      ageSlider2 && (ageSlider2.value = age), ageHidden2 && (ageHidden2.value = age), ageValue2 && (ageValue2.textContent = age), root.querySelectorAll("[data-gender-pick]").forEach(function(btn) {
        var on = btn.getAttribute("data-gender-pick") === state.childGender;
        btn.classList.toggle("is-active", on), btn.setAttribute("aria-pressed", on ? "true" : "false");
      });
    }
    function isValidEmail(value) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || "").trim());
    }
    function isValidWhatsapp(value) {
      var digits = String(value || "").replace(/\D/g, "");
      return digits.length >= 8 && digits.length <= 15;
    }
    function syncSaveContactUI() {
      var fullName = [state.childFirst, state.childLast].filter(Boolean).join(" ") || "Tu h\xE9roe", chip = root.querySelector("[data-save-name-chip]");
      chip && (chip.textContent = fullName);
      var first = state.childFirst || "tu h\xE9roe", sub = root.querySelector("[data-save-subcopy]"), method = state.contactMethod || "email";
      root.querySelectorAll("[data-contact-method]").forEach(function(tab) {
        var on = tab.getAttribute("data-contact-method") === method;
        tab.classList.toggle("is-active", on), tab.setAttribute("aria-selected", on ? "true" : "false");
      }), root.querySelectorAll("[data-contact-panel]").forEach(function(panel) {
        panel.hidden = panel.getAttribute("data-contact-panel") !== method;
      }), sub && (method === "whatsapp" ? sub.textContent = "Introduce tu n\xFAmero de WhatsApp y te enviamos el avatar en alta resoluci\xF3n de " + first + "." : sub.textContent = "Introduce tu correo y te enviamos el avatar en alta resoluci\xF3n de " + first + " a la bandeja de entrada.");
      var emailInput = root.querySelector("[data-contact-email]"), waInput = root.querySelector("[data-contact-whatsapp]"), emailField = emailInput && emailInput.closest(".ms-wiz-save-field"), waField = waInput && waInput.closest(".ms-wiz-save-field"), emailOk = root.querySelector("[data-email-ok]"), waOk = root.querySelector("[data-whatsapp-ok]"), btn = root.querySelector("[data-save-continue]"), label = root.querySelector("[data-save-continue-label]");
      emailInput && state.contactEmail && (emailInput.value = state.contactEmail), waInput && state.contactWhatsapp && (waInput.value = state.contactWhatsapp);
      var emailValid = isValidEmail(emailInput && emailInput.value), waValid = isValidWhatsapp(waInput && waInput.value);
      emailField && emailField.classList.toggle("is-valid", emailValid), waField && waField.classList.toggle("is-valid", waValid), emailOk && (emailOk.hidden = !emailValid), waOk && (waOk.hidden = !waValid);
      var ready2 = method === "whatsapp" ? waValid : emailValid;
      btn && (btn.disabled = !ready2), label && (label.innerHTML = ready2 ? 'Guardar avatar <span aria-hidden="true">\u2192</span>' : method === "whatsapp" ? 'Introduce el n\xFAmero de WhatsApp <span aria-hidden="true">\u2191</span>' : 'Introduce el correo electr\xF3nico <span aria-hidden="true">\u2191</span>');
    }
    function continueAfterSave() {
      go(hasGrandmaFlow ? "add-grandma" : "book-preview");
    }
    function readChildMeta() {
      var ageHidden2 = root.querySelector("[data-child-age]"), ageSlider2 = root.querySelector("[data-child-age-slider]");
      return state.childAge = ageHidden2 && ageHidden2.value || ageSlider2 && ageSlider2.value || "4", (!state.childGender || state.childGender !== "girl" && state.childGender !== "boy") && (state.childGender = "neutral"), true;
    }
    function validateGrandmaDetails() {
      var nameInput = root.querySelector("[data-grandma-name]"), name = (nameInput && nameInput.value || "").trim();
      return nameInput && nameInput.classList.remove("is-invalid"), name ? (state.grandmaName = name, true) : (nameInput && (nameInput.classList.add("is-invalid"), nameInput.focus()), showError({ title: "Necesitamos el nombre de la abuela", body: "Dinos c\xF3mo la llamamos en el libro y pulsa Reintentar para continuar.", retry: function() {
        hideError(), nameInput && nameInput.focus();
      } }), false);
    }
    function ensureChildPhoto() {
      var photo = state.childFileUrl;
      return photo ? Promise.resolve(originalPhotoUpload).catch(function() {
        return null;
      }).then(function() {
        if (photo !== state.childFileUrl) throw new Error("child_photo_changed");
        if (!state.originalPhotoUrl) return originalPhotoUpload = archivePreview({ kind: "child", status: "preview", required: true }), originalPhotoUpload;
      }).then(function() {
        if (photo !== state.childFileUrl || !/^https:\/\//.test(state.originalPhotoUrl)) throw new Error("child_photo_not_saved");
      }) : Promise.reject(new Error("child_photo_missing"));
    }
    function ensureGrandmaPhoto() {
      if (!state.includeGrandma) return Promise.resolve();
      var key = state.grandmaArchiveKey;
      if (!state.grandmaFileUrl) return Promise.reject(new Error("grandma_photo_missing"));
      return (state.grandmaPhotoUrl ? Promise.resolve() : archivePreview({kind:"grandma",status:"preview",required:true})).then(function() {
        if (key !== state.grandmaArchiveKey || !/^https:\/\//.test(state.grandmaPhotoUrl)) throw new Error("grandma_photo_not_saved");
      });
    }
    function addToCart() {
      if (!addingToCart) {
        addingToCart = true;
        updateNumberedSteps();
        var btn = root.querySelector('[data-step="' + state.step + '"] [data-wiz-next]') || root.querySelector("[data-wiz-addtocart]"), label = btn && btn.querySelector(".ms-wiz-btn__label");
        return btn && (btn.disabled = true), label && (label.textContent = "A\xF1adiendo\u2026"), ensureChildPhoto().then(function() {
          return ensureGrandmaPhoto();
        }).then(function() { return addToCartWithPhoto(); }).catch(function(err) {
          btn && (btn.disabled = false), label && (label.textContent = "A\xF1adir a la cesta \u2014 Continuar"), showError({ reason: "child_photo_not_saved", error_message: err && err.message || "child_photo_not_saved", title: "No hemos podido guardar la foto", body: "Pulsa Reintentar para adjuntar la foto a tu libro.", retry: function() {
            hideError(), addToCart();
          } });
        }).then(function() {
          addingToCart = false;
          updateNumberedSteps();
        }, function() {
          addingToCart = false, updateNumberedSteps(), btn && (btn.disabled = false), label && (label.textContent = "A\xF1adir a la cesta \u2014 Continuar");
        });
      }
    }
    function addToCartWithPhoto() {
      var props = { _preview_shell: "true", "Child first name": state.childFirst, "Child last name": state.childLast || "", "Child age": state.childAge || "", "Child gender": state.childGender || "", Book: root.getAttribute("data-product-title") || "" };
      state.heroUrl && (props["Hero image URL"] = state.heroUrl), state.coverUrl && (props["Cover preview URL"] = state.coverUrl), state.originalPhotoUrl && (props["Child photo URL"] = state.originalPhotoUrl), state.grandmaPhotoUrl && (props["Grandma photo URL"] = state.grandmaPhotoUrl), state.archiveKey && (props._funnel_photo_key = state.archiveKey), state.grandmaArchiveKey && (props._grandma_photo_key = state.grandmaArchiveKey), state.heroSeed != null && (props["Hero seed"] = String(state.heroSeed)), state.heroRequestId && (props["Hero generation id"] = state.heroRequestId), state.contactSaved && (props["Contact method"] = state.contactMethod || "email", state.contactMethod === "whatsapp" && state.contactWhatsapp && (props.WhatsApp = state.contactWhatsapp), state.contactEmail && (props.Email = state.contactEmail)), hasGrandmaFlow && (props["Include grandma"] = state.includeGrandma ? "Yes (+4,99 \u20AC)" : "No", state.includeGrandma && (props["Nombre de la abuela"] = state.grandmaName || "")), track("preview_add_to_cart_clicked", { include_grandma: !!state.includeGrandma, child_age: state.childAge || null, child_gender: state.childGender || null });
      var btn = root.querySelector('[data-step="' + state.step + '"] [data-wiz-next]') || root.querySelector("[data-wiz-addtocart]"), label = btn && btn.querySelector(".ms-wiz-btn__label");
      return btn && (btn.disabled = true, label && (label.textContent = "A\xF1adiendo\u2026")), Promise.resolve().then(function() {
        return fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items: window.bfkBundleCartItems ? window.bfkBundleCartItems(String(getVariantId()), props) : [{ id: Number(getVariantId()), quantity: 1, properties: props }] }) });
      }).then(function(r) {
        if (!r.ok) { var cartError = new Error("cart_http_" + r.status); cartError.status = r.status; throw cartError; }
        return r.json();
      }).then(function() {
        archivePreview({ skipPhoto: true, status: "ordered" }), track("preview_add_to_cart_success", { include_grandma: !!state.includeGrandma, funnel_elapsed_ms: funnelStartedAt ? Date.now() - funnelStartedAt : null }), !(window.bfkBundleNext && window.bfkBundleNext(String(getVariantId()))) && (window.location.href = "/cart");
      }).catch(function(err) {
        track("preview_add_to_cart_failed", { error_code: classifyFailure(err), http_status: err && err.status }), btn && (btn.disabled = false, label && (label.textContent = "A\xF1adir a la cesta \u2014 Continuar")), showError({ reason: "add_to_cart_failed", retry: function() {
          hideError(), addToCart();
        } });
      });
    }
    openers.forEach(function(el) {
      el.addEventListener("click", function(e) {
        e.preventDefault();
        var source = el.getAttribute("data-ph-source") || el.getAttribute("data-open-preview") || "preview_cta";
        track("preview_cta_clicked", { source, cta_text: (el.textContent || "").trim().slice(0, 80), cta_tag: el.tagName }), open(source);
      });
    }), root.querySelectorAll("[data-wiz-close]").forEach(function(el) {
      el.addEventListener("click", function() {
        close(el.classList.contains("ms-wiz__backdrop") ? "backdrop" : "close_button");
      });
    }), backBtn && backBtn.addEventListener("click", function() {
      if (track("preview_back_clicked", { from_step: state.step }), state.step === "meet-hero") return go("child-meta", { replace: true });
      if (state.step === "see-cover") return go("meet-hero", { replace: true });
      if (state.step === "save-contact") return isCoverBook() ? go("see-cover", { replace: true }) : go("meet-hero", { replace: true });
      if (state.step === "add-grandma") return go("meet-hero", { replace: true });
      if (state.step === "upload-grandma") return go("add-grandma", { replace: true });
      if (state.step === "grandma-details") return go("upload-grandma", { replace: true });
      if (state.step === "book-preview") return hasGrandmaFlow && state.includeGrandma ? go("grandma-details", { replace: true }) : hasGrandmaFlow ? go("add-grandma", { replace: true }) : go("save-contact", { replace: true });
      if (state.step === "child-meta") return go("child-details", { replace: true });
      if (state.step === "child-details") return go("upload-child", { replace: true });
      close("back");
    });
    var childFile = root.querySelector("[data-child-file]");
    childFile && (childFile.addEventListener("click", function() {
      track("preview_photo_picker_opened", { photo_kind: "child" });
    }), childFile.addEventListener("change", function() {
      var file = childFile.files && childFile.files[0];
      file && (handlePhotoSelect(file, "child"), setTimeout(function() {
        try {
          childFile.value = "";
        } catch (e) {
        }
      }, 0));
    }));
    var grandmaFile = root.querySelector("[data-grandma-file]");
    grandmaFile && (grandmaFile.addEventListener("click", function() {
      track("preview_photo_picker_opened", { photo_kind: "grandma" });
    }), grandmaFile.addEventListener("change", function() {
      var file = grandmaFile.files && grandmaFile.files[0];
      file && (handlePhotoSelect(file, "grandma"), setTimeout(function() {
        try {
          grandmaFile.value = "";
        } catch (e) {
        }
      }, 0));
    }));
    var childFirstInput = root.querySelector("[data-child-first]"), childLastInput = root.querySelector("[data-child-last]");
    childFirstInput && (childFirstInput.addEventListener("input", syncNameUI), childFirstInput.addEventListener("keydown", function(e) {
      if (e.key === "Enter") {
        e.preventDefault();
        var btn = root.querySelector("[data-name-continue]");
        btn && !btn.disabled && btn.click();
      }
    })), childLastInput && (childLastInput.addEventListener("input", syncNameUI), childLastInput.addEventListener("keydown", function(e) {
      if (e.key === "Enter") {
        e.preventDefault();
        var btn = root.querySelector("[data-name-continue]");
        btn && !btn.disabled && btn.click();
      }
    })), root.querySelectorAll("[data-gender-pick]").forEach(function(btn) {
      btn.addEventListener("click", function() {
        state.childGender = btn.getAttribute("data-gender-pick") || "neutral", syncMetaUI(), track("preview_gender_selected", { child_gender: state.childGender });
      });
    });
    var ageSlider = root.querySelector("[data-child-age-slider]"), ageHidden = root.querySelector("[data-child-age]"), ageValue = root.querySelector("[data-age-value]");
    ageSlider && (ageSlider.addEventListener("input", function() {
      var v = ageSlider.value;
      state.childAge = v, ageHidden && (ageHidden.value = v), ageValue && (ageValue.textContent = v);
    }), ageSlider.addEventListener("change", function() {
      track("preview_age_selected", { child_age: ageSlider.value });
    })), state.childAge = state.childAge || "4", root.querySelectorAll("[data-wiz-next]").forEach(function(btn) {
      btn.addEventListener("click", function() {
        if (track("preview_continue_clicked", { from_step: state.step }), state.step === "child-details") {
          if (!validateChildDetails()) {
            track("preview_child_details_invalid");
            return;
          }
          if (track("preview_child_details_submitted", { has_last_name: !!state.childLast }), archivePreview({ skipPhoto: true, status: "preview" }), state.editingNameFromSave) {
            state.editingNameFromSave = false, go("save-contact");
            return;
          }
          go("child-meta");
          return;
        }
        if (state.step === "child-meta") {
          readChildMeta(), track("preview_child_meta_submitted", { child_age: state.childAge || null, child_gender: state.childGender || null }), archivePreview({ skipPhoto: true, status: "generating" }), runGenerating();
          return;
        }
        if (state.step === "meet-hero") {
          if (track("preview_hero_accepted", { hero_index: state.heroIndex }), generationPending || addingToCart) return;
          hasGrandmaFlow ? go("add-grandma") : addToCart();
          return;
        }
        if (state.step === "see-cover") {
          if (state.coverPending || state.coverFailed || !coverDisplayUrl()) return;
          track("preview_cover_accepted", { has_cover: !!state.coverUrl }), go("save-contact");
          return;
        }
        if (state.step === "save-contact") {
          var method = state.contactMethod || "email", emailInput = root.querySelector("[data-contact-email]"), waInput = root.querySelector("[data-contact-whatsapp]");
          if (state.contactEmail = (emailInput && emailInput.value || "").trim(), state.contactWhatsapp = (waInput && waInput.value || "").trim(), method === "email" && !isValidEmail(state.contactEmail)) {
            syncSaveContactUI();
            return;
          }
          if (method === "whatsapp" && !isValidWhatsapp(state.contactWhatsapp)) {
            syncSaveContactUI();
            return;
          }
          state.contactSaved = true;
          var contactProps = { contact_method: method, has_email: !!state.contactEmail, has_whatsapp: !!state.contactWhatsapp }, contactContext = productCtx();
          track("preview_contact_submitted", contactProps), archivePreview({ skipPhoto: true, status: "contacted" }).then(function(result) {
            track(result && result.ok === true && result.archiveId && !result.skipped ? "preview_contact_saved" : "preview_contact_save_failed", Object.assign({}, contactContext, contactProps));
          }), continueAfterSave();
          return;
        }
        if (state.step === "grandma-details") {
          if (!validateGrandmaDetails()) {
            track("preview_grandma_details_invalid");
            return;
          }
          track("preview_grandma_details_submitted"), addToCart();
        }
      });
    }), root.querySelectorAll("[data-contact-method]").forEach(function(tab) {
      tab.addEventListener("click", function() {
        state.contactMethod = tab.getAttribute("data-contact-method") || "email", syncSaveContactUI(), track("preview_contact_method_selected", { contact_method: state.contactMethod });
      });
    });
    var emailInputEl = root.querySelector("[data-contact-email]"), waInputEl = root.querySelector("[data-contact-whatsapp]");
    emailInputEl && emailInputEl.addEventListener("input", function() {
      state.contactEmail = emailInputEl.value, syncSaveContactUI();
    }), waInputEl && waInputEl.addEventListener("input", function() {
      state.contactWhatsapp = waInputEl.value, syncSaveContactUI();
    });
    var editNameBtn = root.querySelector("[data-edit-name]");
    editNameBtn && editNameBtn.addEventListener("click", function() {
      state.editingNameFromSave = true, track("preview_edit_name_clicked"), go("child-details");
    });
    var saveSkip = root.querySelector("[data-save-skip]");
    saveSkip && saveSkip.addEventListener("click", function() {
      track("preview_contact_skipped"), continueAfterSave();
    }), root.querySelectorAll("[data-wiz-regen]").forEach(function(regen) {
      regen.addEventListener("click", function() {
        regenerateHero();
      });
    }), root.querySelectorAll("[data-wiz-restart]").forEach(function(restart) {
      restart.addEventListener("click", function() {
        track("preview_funnel_restarted", { from_step: state.step }), go("upload-child", { replace: true });
      });
    });
    var grandmaYes = root.querySelector("[data-grandma-yes]");
    grandmaYes && grandmaYes.addEventListener("click", function() {
      state.includeGrandma = true, track("preview_grandma_chose_yes"), go("upload-grandma");
    });
    var grandmaSkip = root.querySelector("[data-grandma-skip]");
    grandmaSkip && grandmaSkip.addEventListener("click", function() {
      state.includeGrandma = false, state.grandmaName = "", track("preview_grandma_skipped"), addToCart();
    }), root.querySelectorAll("[data-page-src]").forEach(function(btn) {
      btn.addEventListener("click", function() {
        var src = btn.getAttribute("data-page-src"), cover = root.querySelector("[data-book-cover]");
        if (root.querySelectorAll("[data-page-src]").forEach(function(b) {
          b.classList.toggle("is-active", b === btn);
        }), cover && src) {
          var firstPage = btn === root.querySelector("[data-page-src]");
          cover.src = firstPage && coverDisplayUrl() ? coverDisplayUrl() : src, cover.parentElement && cover.parentElement.classList.toggle("is-personal-cover", firstPage && !!coverDisplayUrl());
        }
        track("preview_book_page_selected", { page_index: Array.prototype.indexOf.call(root.querySelectorAll("[data-page-src]"), btn) });
      });
    });
    var addBtn = root.querySelector("[data-wiz-addtocart]");
    addBtn && addBtn.addEventListener("click", addToCart), errorRetry && errorRetry.addEventListener("click", function() {
      track("preview_error_retry_clicked", { wizard_step: state.step });
      var fn = retryFn;
      hideError(), fn && fn();
    }), photoBannerClose && photoBannerClose.addEventListener("click", function() {
      track("preview_photo_banner_dismissed"), hidePhotoBanner();
    }), /[?&]ms_wiz_error=1(?:&|$)/.test(window.location.search) && (open("demo_error"), go("child-details", { replace: true }), showError({ reason: "demo", retry: function() {
      hideError();
    } })), /[?&]ms_wiz_photo=1(?:&|$)/.test(window.location.search) && (open("demo_photo"), showPhotoBanner({ format: true, maxSize: true, minRes: false, maxRes: true, ok: false, canProceed: true })), document.addEventListener("keydown", function(e) {
      if (e.key === "Escape" && !root.hidden) {
        if (errorEl && !errorEl.hidden) {
          hideError();
          return;
        }
        close("escape");
      }
    });
  });
})();
